"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTabs = void 0;
var palette_1 = require("../../../theme/global/palette");
exports.MuiTabs = {
    root: {
        minHeight: 27,
    },
    flexContainer: {
        borderBottom: "1px solid ".concat(palette_1.palette.grey[300]),
        width: 'fit-content',
    },
    indicator: {
        backgroundColor: 'transparent',
        borderBottom: "1px solid ".concat(palette_1.palette.primary.main),
    },
};
